export default {
    props: {
        userIconUrl: {
            type: String,
            default: undefined,
            kComposite: 'user.iconUrl'
        }, 
        userName: {
            type: String,
            default: undefined,
            kComposite: 'user.name'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-chat-vue-wrapper/src/KendoChat/User.js